import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const eventService = {
  getAll,
  deleteEvent,
  lastEvent
};

function getAll(pageNumber) {
  const requestOptions = {
    method: 'GET',
    headers: Object.assign(
      {},
      {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    )
  };

  let url = `${process.env.REACT_APP_API_URL}/api/events/?page[number]=${
    pageNumber ? pageNumber : 1
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}

function lastEvent() {
  const requestOptions = {
    headers: {
      Accept: 'application/json'
    }
  };
  let url = `${process.env.REACT_APP_API_URL}/api/events/last_event`;

  return axios.get(url, requestOptions);
}

function deleteEvent(eventId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/events/${eventId}`;

  return axios.delete(url, requestOptionsDelete);
}
